module.exports = __webpack_public_path__ + "img/linkedin.e9c9b83.png";